import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { InquiryForm } from '../components/InquiryForm';
import { Footer } from '../components/Footer';
export function QuotePage() {
  return <div className="min-h-screen flex flex-col" data-id="element-176">
      <header className="py-6 px-4 sm:px-6 lg:px-8 border-b border-white/5 bg-tcp-black relative z-10" data-id="element-177">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-178">
          <Link to="/" className="text-tcp-gray hover:text-white transition-colors flex items-center gap-2 text-sm font-medium self-start sm:self-auto" data-id="element-179">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-180" />
            Back to home
          </Link>
          <Link to="/" className="flex-shrink-0" data-id="element-181">
            <img src="https://cdn.magicpatterns.com/uploads/jGwG5Z9Yokuafa2USNXiZs/TCP_LOGO_-_1_-_Edited.png" alt="The Christmas Palace" className="w-[150px] h-auto object-contain" data-id="element-182" />
          </Link>
          <div className="hidden sm:block w-[100px]" data-id="element-183"></div>{' '}
          {/* Spacer for centering */}
        </div>
      </header>

      <main className="flex-grow bg-tcp-black py-16 px-4 sm:px-6 lg:px-8 relative" data-id="element-184">
        {/* Subtle background glow */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-tcp-red/10 blur-[120px] rounded-full pointer-events-none" data-id="element-185" />

        <div className="relative z-10 max-w-4xl mx-auto mb-12 text-center" data-id="element-186">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-187">
            <h1 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-188">
              Request a Quote
            </h1>
            <p className="text-tcp-gray text-lg max-w-2xl mx-auto" data-id="element-189">
              Planning a new installation or seasonal décor program? Complete
              the form below and a member of our commercial team will contact
              you within 24 hours with a custom quote.
            </p>
          </motion.div>
        </div>

        <InquiryForm variant="quote" data-id="element-190" />
      </main>

      <Footer data-id="element-191" />
    </div>;
}